import solar_anim from "../../../../src/content/blog/1-Numerical/NBody/videos/solar_anim.mp4";
import figure8 from "../../../../src/content/blog/1-Numerical/NBody/videos/figure8_anim.mp4";
import * as React from 'react';
export default {
  solar_anim,
  figure8,
  React
};